<template>
  <details v-if="entry.sections && entry.sections.length > 0"
    :open="entry.containsCurrentSection"
    class="SectionOrSubsections"
  >
    <summary>
      <span v-html="caretSvg" class="dropdownIcon" />
      <span>{{ entry.title }}</span>
    </summary>
    <SectionOrSubsections v-for="entry in entry.sections"
      :key="entry.title"
      v-bind="{ entry }"
      class="childSectionOrSubsections"
    />
  </details>
  <div v-else class="SectionOrSubsections">
    <span class="currentSection" v-if="entry.isCurrentSection">
      {{ entry.title }}
    </span>
    <a v-else :href="entry.path">
      {{ entry.title }}
    </a>
  </div>
</template>

<script setup>
import caretSvg from '~/assets/ui/dropdown-caret.svg?raw'

const { entry } = defineProps({
  entry: {
    type: Object,
    default: Object,
  },
})
</script>

<style scoped>

.SectionOrSubsections > .SectionOrSubsections {
  margin-left: 1rem;
}

.SectionOrSubsections > summary {
  cursor: pointer;
}

.dropdownIcon {
  display: inline-block;
  width: 1rem;
}

.dropdownIcon:deep(svg) {
  width: 11px;
  transform: rotate(-90deg);
  transition: transform 0.15s;
}

details.SectionOrSubsections[open] > summary >.dropdownIcon:deep(svg) {
  transform: none;
}

details.SectionOrSubsections[open] > summary {
  font-weight: 600;
}

.sectionOrSubsection {
  margin-top: var(--spacing-0);
}

a {
  transition: color 0.15s;
}

a:hover, .currentSection {
  font-weight: 500;
  color: var(--brand-color);
}

.childSectionOrSubsections {
  margin-top: var(--spacing-2);
}
</style>
